import React, { useState, useEffect } from 'react';
import {
  Modal,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
  Box,
  Container,
  IconButton,
  Tabs,
  Tab,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useLocation, useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import Footer from '../Materials/Footer';
import BurgerBar from '../Materials/BurgerBar';

export default function EditInvestigationGroupAndMatrixPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const showNotification = (message, severity = 'success') => {
    setNotification({
      open: true,
      message,
      severity
    });
  };

  const handleCloseNotification = () => {
    setNotification((prev) => ({
      ...prev,
      open: false
    }));
  };


  const [selectedTab, setSelectedTab] = useState(0);

  const [entities, setEntities] = useState([]);
  const [currentEntityIndex, setCurrentEntityIndex] = useState(0);
  const [entityName, setEntityName] = useState('');
  const [entityWebsite, setEntityWebsite] = useState('');
  const [entityHeadOffice, setEntityHeadOffice] = useState('');
  const [entityEmailContact, setEntityEmailContact] = useState('');
  const [entityMainLocation, setEntityMainLocation] = useState('');
  const [entityOtherLocation, setEntityOtherLocation] = useState('');
  const [entityLatitudeCords, setEntityLatitudeCords] = useState('');
  const [entityLongitudeCords, setEntityLongitudeCords] = useState('');
  const [entityDescription, setEntityDescription] = useState('');
  const [entityIsVerified, setEntityIsVerified] = useState(false);
  const [entityIsAssociate, setEntityIsAssociate] = useState(false);
  const [entityIsVisible, setEntityIsVisible] = useState(false);
  const [entityTypeId, setEntityTypeId] = useState('');
  const [entityTypes, setEntityTypes] = useState([]);
  const [openEntityModal, setOpenEntityModal] = useState(false);
  const [openAddEntityModal, setOpenAddEntityModal] = useState(false);

  const [entity, setEntity] = useState({
    name: '',
    website: '',
    head_office: '',
    email_contact: '',
    main_location: '',
    other_location: '',
    latitude_cords: '',
    longitude_cords: '',
    description: '',
    is_verified: false,
    is_associate: false,
    is_visible: false,
    entity_type_id: '',
  });


  // Estado para armazenar os dados do Investigation Group
  const [newResearchLine, setNewResearchLine] = useState('');
  const [newSubEntityId, setNewSubEntityId] = useState('');
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const entityId = location.state?.entityId || '';
  const [subEntities, setSubEntities] = useState([]);
  const [investigationGroups, setInvestigationGroups] = useState([]);
  const [currentGroupIndex, setCurrentGroupIndex] = useState(0);
  const [subEntityIdIG, setSubEntityIdIG] = useState('');
  const [researchLine, setResearchLine] = useState('');
  const [researcherName, setResearcherName] = useState('');
  const [researcherCv, setResearcherCv] = useState('');
  const [email, setEmail] = useState('');
  const [biography, setBiography] = useState('');
  const [descriptionIG, setDescriptionIG] = useState('');
  const [loading, setLoading] = useState(false);

  // Estado para as Sub-Entities
  const [openAddSubEntityModal, setOpenAddSubEntityModal] = useState(false);
  const [openEditSubEntityModal, setOpenEditSubEntityModal] = useState(false);
  const [subEntityType, setSubEntityType] = useState('');
  const [subEntityName, setSubEntityName] = useState('');
  const [subEntityContact, setSubEntityContact] = useState('');
  const [subEntityLocation, setSubEntityLocation] = useState('');
  const [subEntityId, setSubEntityId] = useState(null);

  // Estados para Food Matrices
  const [openAddMatrixModal, setOpenAddMatrixModal] = useState(false);
  const [newMatrixObservations, setNewMatrixObservations] = useState('');
  const [openMatrixModal, setOpenMatrixModal] = useState(false);
  const [currentMatrixIndex, setCurrentMatrixIndex] = useState(0);
  const [matrixEntityId, setMatrixEntityId] = useState('');
  const [matrixObservations, setMatrixObservations] = useState('');
  const [matrices, setMatrices] = useState([]);

  const [matriceCategoryMatriceId, setMatriceCategoryMatriceId] = useState('');
  const [matriceCategoryDescription, setMatriceCategoryDescription] = useState('');
  const [matriceSubcategoryCategoryId, setMatriceSubcategoryCategoryId] = useState('');
  const [matriceSubcategoryDescription, setMatriceSubcategoryDescription] = useState('');
  const [openCategoryModal, setOpenCategoryModal] = useState(false);
  const [openSubcategoryModal, setOpenSubcategoryModal] = useState(false);
  const [matriceCategories, setMatriceCategories] = useState([]);

  const handleOpenCategoryModal = () => setOpenCategoryModal(true);
  const handleCloseCategoryModal = () => setOpenCategoryModal(false);

  const handleOpenSubcategoryModal = () => setOpenSubcategoryModal(true);
  const handleCloseSubcategoryModal = () => setOpenSubcategoryModal(false);

  // Estado para armazenar os Equipments
  const [equipments, setEquipments] = useState([]);
  const [currentEquipmentIndex, setCurrentEquipmentIndex] = useState(0);
  const [equipmentName, setEquipmentName] = useState('');
  const [applications, setApplications] = useState('');
  const [observations, setObservations] = useState('');
  const [scales, setScales] = useState('');
  const [mainSpecs, setMainSpecs] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [matriceId, setMatriceId] = useState('');
  const [processType, setProcessType] = useState('');
  const [categories, setCategories] = useState([]);
  const [matricesOptions, setMatricesOptions] = useState([]);
  const [processTypes, setProcessTypes] = useState([]);
  const [openEquipmentModal, setOpenEquipmentModal] = useState(false);

  const [openAddEquipmentModal, setOpenAddEquipmentModal] = useState(false);
  const [newEquipmentName, setNewEquipmentName] = useState('');
  const [newApplications, setNewApplications] = useState('');
  const [newObservations, setNewObservations] = useState('');
  const [newScales, setNewScales] = useState('');
  const [newMainSpecs, setNewMainSpecs] = useState('');
  const [newCategoryId, setNewCategoryId] = useState('');
  const [newMatriceId, setNewMatriceId] = useState('');
  const [newProcessType, setNewProcessType] = useState('');

  // Estado para armazenar os Skills (R&I)
  const [skills, setSkills] = useState([]);
  const [currentSkillIndex, setCurrentSkillIndex] = useState(0);
  const [mainKeywords, setMainKeywords] = useState('');
  const [researchTopics, setResearchTopics] = useState('');
  const [specificKeywords, setSpecificKeywords] = useState('');
  const [researchAreasFieldId, setResearchAreasFieldId] = useState('');
  const [openSkillModal, setOpenSkillModal] = useState(false);
  const [researchAreasOptions, setResearchAreasOptions] = useState([]);

  const [openAddSkillModal, setOpenAddSkillModal] = useState(false);
  const [newMainKeywords, setNewMainKeywords] = useState('');
  const [newResearchTopics, setNewResearchTopics] = useState('');
  const [newSpecificKeywords, setNewSpecificKeywords] = useState('');
  const [newResearchAreasFieldId, setNewResearchAreasFieldId] = useState('');

  // Estado para armazenar as Patents
  const [patents, setPatents] = useState([]);
  const [currentPatentIndex, setCurrentPatentIndex] = useState(0);
  const [publicationNumber, setPublicationNumber] = useState('');
  const [publicationDate, setPublicationDate] = useState('');
  const [title, setTitle] = useState('');
  const [inventor, setInventor] = useState('');

  const [openAddPatentModal, setOpenAddPatentModal] = useState(false);
  const [newPublicationNumber, setNewPublicationNumber] = useState('');
  const [newPublicationDate, setNewPublicationDate] = useState('');
  const [newTitle, setNewTitle] = useState('');
  const [newInventor, setNewInventor] = useState('');

  // Estado para armazenar os Projects
  const [projects, setProjects] = useState([]);
  const [currentProjectIndex, setCurrentProjectIndex] = useState(0);
  const [projectName, setProjectName] = useState('');
  const [link, setLink] = useState('');
  const [onGoing, setOnGoing] = useState(false);
  const [projectAcronym, setProjectAcronym] = useState('');

  const [openAddProjectModal, setOpenAddProjectModal] = useState(false);
  const [newProjectName, setNewProjectName] = useState('');
  const [newLink, setNewLink] = useState('');
  const [newOnGoing, setNewOnGoing] = useState(false);
  const [newProjectAcronym, setNewProjectAcronym] = useState('');

  // Estado para controlar a visibilidade dos modais
  const [openPatentModal, setOpenPatentModal] = useState(false);
  const [openProjectModal, setOpenProjectModal] = useState(false);

  // Estado para armazenar os dados dos campos enquanto edita
  const [currentPatent, setCurrentPatent] = useState(null);
  const [currentProject, setCurrentProject] = useState(null);

  // Função para abrir o modal de edição de patente
  const handleEditPatentClick = (index) => {
    const patent = patents[index];
    setCurrentPatent(patent);
    setPublicationNumber(patent.publication_number || '');
    setPublicationDate(patent.publication_date || '');
    setTitle(patent.title || '');
    setInventor(patent.inventor || '');
    setOpenPatentModal(true);
  };

  // Função para abrir o modal de edição de projeto
  const handleEditProjectClick = (index) => {
    const project = projects[index];
    setCurrentProject(project);
    setProjectName(project.project_name || '');
    setLink(project.link || '');
    setOnGoing(project.on_going || false);
    setProjectAcronym(project.project_acronimo || '');
    setOpenProjectModal(true);
  };

  // Função para alterar a aba
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  // Função para abrir o modal e preencher os dados do grupo
  const handleEditClick = (index) => {
    setCurrentGroupIndex(index);
    const group = investigationGroups[index];
    setSubEntityIdIG(group.sub_entity_id || '');
    setResearchLine(group.research_line || '');
    setResearcherName(group.researcher_name || '');
    setResearcherCv(group.researcher_cv || '');
    setEmail(group.email || '');
    setBiography(group.biography || '');
    setDescriptionIG(group.description || '');
    setOpenModal(true);
  };

  // Função para fechar o modal
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleOpenAddModal = () => {
    setOpenAddModal(true);
  };

  // Função para fechar o modal
  const handleCloseAddModal = () => {
    setOpenAddModal(false);
    setNewResearchLine('');
    setNewSubEntityId('');
  };

  const fetchEntityTypes = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/entity-types');
      const data = await response.json();
      setEntityTypes(data);
    } catch (error) {
      console.error('Erro ao buscar tipos de entidade:', error);
    }
  };

  const fetchEntities = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/entities');
      const data = await response.json();
      setEntities(data);
    } catch (error) {
      console.error('Erro ao buscar entidades:', error);
    }
  };

  useEffect(() => {
    if (entityId) {
      fetchEntityDetails(entityId);
    }
  }, [entityId]);

  const fetchEntityDetails = async (id) => {
    setLoading(true);
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/entities/${id}`);
      const data = await response.json();
      setEntity(data);
    } catch (error) {
      console.error('Erro ao buscar detalhes da entidade:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateEntity = async () => {
    setLoading(true);
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/entities/${entityId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(entity),
      });

      if (!response.ok) {
        throw new Error('Erro ao atualizar a entidade');
      }

      showNotification('Entidade atualizada com sucesso!', 'success');
    } catch (error) {
      console.error('Erro ao atualizar entidade:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEntity((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleEditEntity = async () => {
    const updatedEntity = {
      entity_type_id: entityTypeId,
      name: entityName,
      website: entityWebsite,
      head_office: entityHeadOffice,
      email_contact: entityEmailContact,
      main_location: entityMainLocation,
      other_location: entityOtherLocation,
      latitude_cords: entityLatitudeCords,
      longitude_cords: entityLongitudeCords,
      description: entityDescription,
      is_verified: entityIsVerified,
      is_associate: entityIsAssociate,
      is_visible: entityIsVisible,
    };

    try {
      const response = await fetch(
        `https://api.hub4food.colab4food.com/api/entities/${entities[currentEntityIndex].id}`,
        {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedEntity),
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao editar a entidade');
      }

      showNotification('Entidade editada com sucesso!', 'success');
      setOpenEntityModal(false);
    } catch (error) {
      showNotification('Erro ao editar entidade', 'error');
      console.error(error);
    }
  };

  const handleAddEntity = async () => {
    setLoading(true);

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/entities', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          entity_type_id: entityTypeId,
          name: entityName,
          website: entityWebsite,
          head_office: entityHeadOffice,
          email_contact: entityEmailContact,
          main_location: entityMainLocation,
          other_location: entityOtherLocation,
          latitude_cords: entityLatitudeCords,
          longitude_cords: entityLongitudeCords,
          description: entityDescription,
          is_verified: entityIsVerified,
          is_associate: entityIsAssociate,
          is_visible: entityIsVisible,
        }),
      });

      if (!response.ok) {
        throw new Error('Erro ao criar entidade');
      }

      const createdEntity = await response.json();
      setEntities([...entities, createdEntity]);
      setOpenAddEntityModal(false);
      showNotification('Entidade criada com sucesso!', 'success');
    } catch (error) {
      console.error('Erro ao adicionar entidade:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteEntity = async (id) => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/entities/${id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Erro ao deletar a entidade');
      }

      showNotification('Entidade deletada com sucesso!', 'success');
      setEntities(prevEntities => prevEntities.filter(entity => entity.id !== id));
    } catch (error) {
      showNotification('Erro ao deletar entidade', 'error');
      console.error(error);
    }
  };

  useEffect(() => {
    fetchEntities();
    fetchEntityTypes();
  }, []);

  useEffect(() => {
    if (entities.length > 0) {
      const currentEntity = entities[currentEntityIndex];
      setEntityTypeId(currentEntity.entity_type_id);
      setEntityName(currentEntity.name);
      setEntityWebsite(currentEntity.website);
      setEntityHeadOffice(currentEntity.head_office);
      setEntityEmailContact(currentEntity.email_contact);
      setEntityMainLocation(currentEntity.main_location);
      setEntityOtherLocation(currentEntity.other_location);
      setEntityLatitudeCords(currentEntity.latitude_cords);
      setEntityLongitudeCords(currentEntity.longitude_cords);
      setEntityDescription(currentEntity.description);
      setEntityIsVerified(currentEntity.is_verified);
      setEntityIsAssociate(currentEntity.is_associate);
      setEntityIsVisible(currentEntity.is_visible);
    }
  }, [currentEntityIndex, entities]);

  const handleAddInvestigationGroup = async () => {
    setLoading(true);
  
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/investigation-groups', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          entity_id: entityId,
          sub_entity_id: subEntityIdIG === '' ? null : subEntityIdIG,
          research_line: researchLine,
          researcher_name: researcherName,
          researcher_cv: researcherCv,
          email: email,
          biography: biography,
          description: descriptionIG,
        }),
      });
  
      if (!response.ok) {
        throw new Error('Erro ao criar Investigation Group');
      }
  
      const createdGroup = await response.json();
  
      // Atualiza a lista de grupos de investigação
      setInvestigationGroups([...investigationGroups, createdGroup]);
  
      // Atualiza o mapeamento de subentidades (subEntitiesMap)
      if (subEntityIdIG && !subEntitiesMap[subEntityIdIG]) {
        const subEntityResponse = await fetch(
          `https://api.hub4food.colab4food.com/api/sub-entities/${subEntityIdIG}`
        );
        if (subEntityResponse.ok) {
          const subEntity = await subEntityResponse.json();
          setSubEntitiesMap((prevMap) => ({
            ...prevMap,
            [subEntity.id]: subEntity.name,
          }));
        }
      }
  
      setOpenAddModal(false);
      showNotification('Investigação criada com sucesso!', 'success');
      resetForm();
    } catch (error) {
      console.error('Erro ao adicionar grupo:', error);
    } finally {
      setLoading(false);
    }
  };
  const resetForm = () => {
    setSubEntityIdIG('');
    setResearchLine('');
    setResearcherName('');
    setResearcherCv('');
    setEmail('');
    setBiography('');
    setDescriptionIG('');
  };

  const handleAddSubEntity = async () => {
    setLoading(true);

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/sub-entities', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          entity_id: entityId,
          type: subEntityType,
          name: subEntityName,
          contact: subEntityContact,
          location: subEntityLocation,
        }),
      });

      if (!response.ok) {
        throw new Error('Erro ao criar Sub Entity');
      }

      const createdSubEntity = await response.json();
      setSubEntities([...subEntities, createdSubEntity]);
      setOpenAddSubEntityModal(false);
      showNotification('Sub Entity criada com sucesso!', 'success');
    } catch (error) {
      console.error('Erro ao adicionar Sub Entity:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditSubEntity = async () => {
    if (!subEntityId) {
      showNotification('Erro: Nenhuma subentidade selecionada.', 'error');
      return;
    }

    const updatedSubEntity = {
      type: subEntityType,
      name: subEntityName,
      contact: subEntityContact,
      location: subEntityLocation,
    };

    try {
      const response = await fetch(
        `https://api.hub4food.colab4food.com/api/sub-entities/${subEntityId}`, // Usa o ID correto
        {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedSubEntity),
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao editar a Sub Entity');
      }

      showNotification('Sub Entity editada com sucesso!', 'success');
      setOpenEditSubEntityModal(false);

      // Atualizar a lista no frontend
      setSubEntities((prevSubEntities) =>
        prevSubEntities.map((sub) =>
          sub.id === subEntityId ? { ...sub, ...updatedSubEntity } : sub
        )
      );
    } catch (error) {
      showNotification('Erro ao editar Sub Entity', 'error');
      console.error(error);
    }
  };
  const handleDeleteInvestigationGroup = async (id) => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/investigation-groups/${id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Erro ao remover o grupo de investigação');
      }

      showNotification('Grupo de investigação removido com sucesso!', 'success');
      setInvestigationGroups(prevGroups => prevGroups.filter(group => group.id !== id));
    } catch (error) {
      showNotification('Erro ao remover o grupo de investigação', 'error');
      console.error(error);
    }
  };

  const handleDeleteSubEntity = async (id) => {
    try {
      // Verifica se há grupos de investigação associados à subentidade
      const associatedGroups = investigationGroups.filter(
        (group) => group.sub_entity_id === id
      );
  
      if (associatedGroups.length > 0) {
        // Atualiza os grupos de investigação associados para remover a referência à subentidade
        const updatedGroups = investigationGroups.map((group) =>
          group.sub_entity_id === id ? { ...group, sub_entity_id: null } : group
        );
  
        // Atualiza a lista de grupos de investigação no estado
        setInvestigationGroups(updatedGroups);
  
        // Atualiza os grupos de investigação no backend
        await Promise.all(
          associatedGroups.map((group) =>
            fetch(`https://api.hub4food.colab4food.com/api/investigation-groups/${group.id}`, {
              method: 'PATCH',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ sub_entity_id: null }),
            })
          )
        );
      }
  
      // Apaga a subentidade
      const response = await fetch(
        `https://api.hub4food.colab4food.com/api/sub-entities/${id}`,
        {
          method: 'DELETE',
        }
      );
  
      if (!response.ok) {
        throw new Error('Erro ao remover a Sub Entity');
      }
  
      // Remove a subentidade da lista
      setSubEntities((prevSubEntities) =>
        prevSubEntities.filter((subEntity) => subEntity.id !== id)
      );
  
      // Remove a subentidade do mapeamento
      setSubEntitiesMap((prevMap) => {
        const newMap = { ...prevMap };
        delete newMap[id];
        return newMap;
      });
  
      showNotification('Sub Entity removida com sucesso!', 'success');
    } catch (error) {
      showNotification('Erro ao remover Sub Entity', 'error');
      console.error(error);
    }
  };
   
  const handleAddMatrix = async () => {
    setLoading(true);

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/matrices', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          entity_id: entityId,
          observations: newMatrixObservations,
        }),
      });

      if (!response.ok) {
        throw new Error('Erro ao criar Food Matrix');
      }

      const createdMatrix = await response.json();
      setMatrices([...matrices, createdMatrix]);
      setOpenAddMatrixModal(false);
      showNotification('Food Matrix criada com sucesso!', 'success');
    } catch (error) {
      console.error('Erro ao adicionar Food Matrix:', error);
    } finally {
      setLoading(false);
    }
  };

  // Função para criar Matriz
  const handleCreateMatrix = async () => {
    const newMatrix = {
      entity_id: matrixEntityId === '' ? null : matrixEntityId,
      observations: matrixObservations
    };

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/matrices', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newMatrix)
      });

      if (!response.ok) {
        throw new Error('Erro ao criar a matriz');
      }      showNotification('Matriz criada com sucesso!', 'success');
    } catch (error) {
      showNotification('Erro ao criar matriz', 'error');
    }
  };

  // Função para criar Matrice Category
  const handleCreateMatriceCategory = async () => {
    const newMatriceCategory = {
      matrice_id: matriceCategoryMatriceId === '' ? null : matriceCategoryMatriceId,
      description: matriceCategoryDescription,
    };

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/matrice-categories', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newMatriceCategory),
      });

      if (!response.ok) {
        throw new Error('Erro ao criar a categoria de matriz');
      }

      showNotification('Categoria de Matriz criada com sucesso!', 'success');
      handleCloseCategoryModal(); // Fechar o modal após a criação
    } catch (error) {
      showNotification('Erro ao criar categoria de matriz', 'error');
    }
  };

  // Função para criar Matrice Subcategory
  const handleCreateMatriceSubcategory = async () => {
    const newMatriceSubcategory = {
      matrice_category_id: matriceSubcategoryCategoryId === '' ? null : matriceSubcategoryCategoryId,
      description: matriceSubcategoryDescription,
    };

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/matrice-subcategories', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newMatriceSubcategory),
      });

      if (!response.ok) {
        throw new Error('Erro ao criar a subcategoria de matriz');
      }

      showNotification('Subcategoria de Matriz criada com sucesso!', 'success');
      handleCloseSubcategoryModal(); // Fechar o modal após a criação
    } catch (error) {
      showNotification('Erro ao criar subcategoria de matriz', 'error');
    }
  };

  const handleAddEquipment = async () => {
    setLoading(true);

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/equipments', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          entity_id: entityId,
          equipment_name: newEquipmentName,
          applications: newApplications,
          observations: newObservations,
          scales: newScales,
          main_specs: newMainSpecs,
          category_id: newCategoryId || null,
          matrice_id: newMatriceId || null,
          process_type: newProcessType || null,
        }),
      });

      if (!response.ok) {
        throw new Error('Erro ao criar Equipment');
      }

      const createdEquipment = await response.json();
      setEquipments([...equipments, createdEquipment]);
      setOpenAddEquipmentModal(false);
      showNotification('Equipment criado com sucesso!', 'success');
    } catch (error) {
      console.error('Erro ao adicionar Equipment:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddSkill = async () => {
    setLoading(true);

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/skills', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          entity_id: entityId,
          main_keywords: newMainKeywords,
          research_topics: newResearchTopics,
          specific_keywords: newSpecificKeywords,
          research_areas_field_id: newResearchAreasFieldId || null,
        }),
      });

      if (!response.ok) {
        throw new Error('Erro ao criar Skill');
      }

      const createdSkill = await response.json();
      setSkills([...skills, createdSkill]);
      setOpenAddSkillModal(false);
      showNotification('Skill criada com sucesso!', 'success');
    } catch (error) {
      console.error('Erro ao adicionar Skill:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddPatent = async () => {
    setLoading(true);

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/patents', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          entity_id: entityId,
          publication_number: newPublicationNumber,
          publication_date: newPublicationDate,
          title: newTitle,
          inventor: newInventor,
        }),
      });

      if (!response.ok) {
        throw new Error('Erro ao criar Patent');
      }

      const createdPatent = await response.json();
      setPatents([...patents, createdPatent]);
      setOpenAddPatentModal(false);
      showNotification('Patent criada com sucesso!', 'success');
    } catch (error) {
      console.error('Erro ao adicionar Patent:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddProject = async () => {
    setLoading(true);

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/projects', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          entity_id: entityId,
          project_name: newProjectName,
          link: newLink,
          on_going: newOnGoing,
          project_acronimo: newProjectAcronym,
        }),
      });

      if (!response.ok) {
        throw new Error('Erro ao criar Project');
      }

      const createdProject = await response.json();
      setProjects([...projects, createdProject]);
      setOpenAddProjectModal(false);
      showNotification('Project criado com sucesso!', 'success');
    } catch (error) {
      console.error('Erro ao adicionar Project:', error);
    } finally {
      setLoading(false);
    }
  };

  const [entitiesMap, setEntitiesMap] = useState({});
  const [subEntitiesMap, setSubEntitiesMap] = useState({});

  // Função para buscar os dados da API
  useEffect(() => {
    if (entityId) {
      const fetchData = async () => {
        setLoading(true);
        try {
          // Busca Investigation Groups
          const groupsResponse = await fetch(`https://api.hub4food.colab4food.com/api/investigation-groups/entity/${entityId}`);
          const groupsData = await groupsResponse.json();
          setInvestigationGroups(Array.isArray(groupsData) ? groupsData : []);

          // Busca todas as entidades
          const entitiesResponse = await fetch(`https://api.hub4food.colab4food.com/api/entities`);
          const entitiesData = await entitiesResponse.json();

          // Busca todas as subentidades
          const subEntitiesResponse = await fetch(`https://api.hub4food.colab4food.com/api/sub-entities`);
          const subEntitiesData = await subEntitiesResponse.json();
          setSubEntities(Array.isArray(subEntitiesData) ? subEntitiesData : []);

          // Criar mapeamento ID -> Nome
          const entityMap = entitiesData.reduce((acc, entity) => {
            acc[entity.id] = entity.name;
            return acc;
          }, {});

          const subEntityMap = subEntitiesData.reduce((acc, subEntity) => {
            acc[subEntity.id] = subEntity.name;
            return acc;
          }, {});

          setEntitiesMap(entityMap);
          setSubEntitiesMap(subEntityMap);

          // Busca Matrices
          const matricesResponse = await fetch(`https://api.hub4food.colab4food.com/api/matrices/entity/${entityId}`);
          const matricesData = await matricesResponse.json();
          setMatrices(Array.isArray(matricesData) ? matricesData : []);

          // Busca Equipments
          const equipmentsResponse = await fetch(`https://api.hub4food.colab4food.com/api/equipments/entity/${entityId}`);
          const equipmentsData = await equipmentsResponse.json();
          setEquipments(Array.isArray(equipmentsData) ? equipmentsData : []);

          // Busca Skills
          const skillsResponse = await fetch(`https://api.hub4food.colab4food.com/api/skills/entity/${entityId}`);
          const skillsData = await skillsResponse.json();
          setSkills(Array.isArray(skillsData) ? skillsData : []);

          // Busca Patents
          const patentsResponse = await fetch(`https://api.hub4food.colab4food.com/api/patents/entity/${entityId}`);
          const patentsData = await patentsResponse.json();
          setPatents(Array.isArray(patentsData) ? patentsData : []);

          // Busca Projects
          const projectsResponse = await fetch(`https://api.hub4food.colab4food.com/api/projects/entity/${entityId}`);
          const projectsData = await projectsResponse.json();
          setProjects(Array.isArray(projectsData) ? projectsData : []);
        } catch (error) {
          console.error('Erro ao buscar dados:', error);
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }
  }, [entityId]);
  useEffect(() => {
    if (entityId) {
      fetch(`https://api.hub4food.colab4food.com/api/sub-entities?entity_id=${entityId}`)
        .then((response) => response.json())
        .then((data) => setSubEntities(data))
        .catch((error) => console.error("Erro ao buscar sub-entities:", error));
    }
  }, [entityId]);

  const handleDeleteMatrix = async (id) => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/matrices/${id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Erro ao deletar a matriz');
      }

      showNotification('Matriz deletada com sucesso!', 'success');
      setMatrices(prevMatrices => prevMatrices.filter(matrix => matrix.id !== id));
    } catch (error) {
      showNotification('Erro ao deletar matriz', 'error');
      console.error(error);
    }
  };

  const handleDeleteEquipment = async (id) => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/equipments/${id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Erro ao deletar o equipamento');
      }

      showNotification('Equipamento deletado com sucesso!', 'success');
      setEquipments(prevEquipments => prevEquipments.filter(equipment => equipment.id !== id));
    } catch (error) {
      showNotification('Erro ao deletar equipamento', 'error');
      console.error(error);
    }
  };

  const handleDeleteSkill = async (id) => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/skills/${id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Erro ao deletar a skill');
      }

      showNotification('Skill deletada com sucesso!', 'success');
      setSkills(prevSkills => prevSkills.filter(skill => skill.id !== id));
    } catch (error) {
      showNotification('Erro ao deletar skill', 'error');
      console.error(error);
    }
  };

  const handleDeletePatent = async (id) => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/patents/${id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Erro ao deletar a patente');
      }

      showNotification('Patente deletada com sucesso!', 'success');
      setPatents(prevPatents => prevPatents.filter(patent => patent.id !== id));
    } catch (error) {
      showNotification('Erro ao deletar patente', 'error');
      console.error(error);
    }
  };

  const handleDeleteProject = async (id) => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/projects/${id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Erro ao deletar o projeto');
      }

      showNotification('Projeto deletado com sucesso!', 'success');
      setProjects(prevProjects => prevProjects.filter(project => project.id !== id));
    } catch (error) {
      showNotification('Erro ao deletar projeto', 'error');
      console.error(error);
    }
  };

  // Função para editar Equipment
  const handleEditEquipment = async () => {
    const updatedEquipment = {
      equipment_name: equipmentName,
      applications: applications,
      observations: observations,
      scales: scales,
      main_specs: mainSpecs,
      category_id: categoryId || null,
      matrice_id: matriceId || null,
      process_type: processType || null,
    };

    try {
      const response = await fetch(
        `https://api.hub4food.colab4food.com/api/equipments/${equipments[currentEquipmentIndex].id}`,
        {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedEquipment),
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao editar o equipamento');
      }

      showNotification('Equipamento editado com sucesso!', 'success');
      setOpenEquipmentModal(false);
      // Atualizar a lista no frontend
      setEquipments((prevEquipments) =>
        prevEquipments.map((equip) =>
          equip.id === equipments[currentEquipmentIndex].id ? { ...equip, ...updatedEquipment } : equip
        )
      );
    } catch (error) {
      showNotification('Erro ao editar equipamento', 'error');
      console.error(error);
    }
  };

  // Função para editar Skill
  const handleEditSkill = async () => {
    const updatedSkill = {
      main_keywords: mainKeywords,
      research_topics: researchTopics,
      specific_keywords: specificKeywords,
      research_areas_field_id: researchAreasFieldId || null,
    };

    try {
      const response = await fetch(
        `https://api.hub4food.colab4food.com/api/skills/${skills[currentSkillIndex].id}`,
        {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedSkill),
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao editar a skill');
      }

      showNotification('Skill editada com sucesso!', 'success');
      setOpenSkillModal(false);
      // Atualizar a lista no frontend
      setSkills((prevSkills) =>
        prevSkills.map((skill) =>
          skill.id === skills[currentSkillIndex].id ? { ...skill, ...updatedSkill } : skill
        )
      );
    } catch (error) {
      showNotification('Erro ao editar skill', 'error');
      console.error(error);
    }
  };

  // Função para editar Patent
  const handleEditPatent = async () => {
    // Use currentPatent, que já contém todos os dados da patente
    const updatedPatent = {
      publication_number: publicationNumber,
      publication_date: publicationDate,
      title: title,
      inventor: inventor,
    };

    try {
      const response = await fetch(
        `https://api.hub4food.colab4food.com/api/patents/${currentPatent.id}`,  // Use currentPatent.id diretamente
        {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedPatent),
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao editar a patente');
      }

      showNotification('Patente editada com sucesso!', 'success');
      setOpenPatentModal(false);
      // Atualizar a lista no frontend
      setPatents((prevPatents) =>
        prevPatents.map((patent) =>
          patent.id === currentPatent.id ? { ...patent, ...updatedPatent } : patent
        )
      );
    } catch (error) {
      showNotification('Erro ao editar patente', 'error');
      console.error(error);
    }
  };

  // Função para editar Project
  const handleEditProject = async () => {
    // Use currentProject, que já contém todos os dados do projeto
    const updatedProject = {
      project_name: projectName,
      link: link,
      on_going: onGoing,
      project_acronimo: projectAcronym,
    };

    try {
      const response = await fetch(
        `https://api.hub4food.colab4food.com/api/projects/${currentProject.id}`,  // Use currentProject.id diretamente
        {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedProject),
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao editar o projeto');
      }

      showNotification('Projeto editado com sucesso!', 'success');
      setOpenProjectModal(false);
      // Atualizar a lista no frontend
      setProjects((prevProjects) =>
        prevProjects.map((proj) =>
          proj.id === currentProject.id ? { ...proj, ...updatedProject } : proj
        )
      );
    } catch (error) {
      showNotification('Erro ao editar projeto', 'error');
      console.error(error);
    }
  };

  const handleNextItem = (setIndex, index, length) => {
    if (index < length - 1) {
      setIndex(index + 1);
    }
  };

  // Função para navegar para o grupo anterior
  const handlePrevGroup = () => {
    if (currentGroupIndex > 0) {
      setCurrentGroupIndex(currentGroupIndex - 1);
    }
  };

  // Função para navegar para o próximo grupo
  const handleNextGroup = () => {
    if (currentGroupIndex < investigationGroups.length - 1) {
      setCurrentGroupIndex(currentGroupIndex + 1);
    }
  };

  // Função para editar o grupo de investigação
  const handleEditInvestigationGroup = async () => {
    const updatedGroup = {
      sub_entity_id: subEntityIdIG || null,
      research_line: researchLine,
      researcher_name: researcherName,
      researcher_cv: researcherCv,
      email: email,
      biography: biography,
      description: descriptionIG,
    };



    try {
      const response = await fetch(
        `https://api.hub4food.colab4food.com/api/investigation-groups/${investigationGroups[currentGroupIndex].id}`,
        {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedGroup),
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao editar o grupo de investigação');
      }

      showNotification('Grupo de investigação editado com sucesso!', 'success');
      setOpenModal(false);
      // Atualizar a lista no frontend
      setInvestigationGroups((prevGroups) =>
        prevGroups.map((group) =>
          group.id === investigationGroups[currentGroupIndex].id ? { ...group, ...updatedGroup } : group
        )
      );
    } catch (error) {
      showNotification('Erro ao editar grupo de investigação', 'error');
      console.error(error);
    }
  };

  // Abrir Modal de Edição para Food Matrices
  const handleEditMatrixClick = (index) => {
    setCurrentMatrixIndex(index);
    const matrix = matrices[index];
    setMatrixEntityId(matrix.entity_id || '');
    setMatrixObservations(matrix.observations || '');
    setOpenMatrixModal(true);
  };

  // Fechar Modal
  const handleCloseMatrixModal = () => {
    setOpenMatrixModal(false);
  };

  // Função para editar a matriz
  const handleEditMatrix = async () => {
    const updatedMatrix = {
      entity_id: matrixEntityId,
      observations: matrixObservations,
    };

    try {
      const response = await fetch(
        `https://api.hub4food.colab4food.com/api/matrices/${matrices[currentMatrixIndex].id}`,
        {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedMatrix),
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao editar a matriz');
      }

      showNotification('Matriz editada com sucesso!', 'success');
      setOpenMatrixModal(false);
      // Atualizar a lista no frontend
      setMatrices((prevMatrices) =>
        prevMatrices.map((matrix) =>
          matrix.id === matrices[currentMatrixIndex].id ? { ...matrix, ...updatedMatrix } : matrix
        )
      );
    } catch (error) {
      showNotification('Erro ao editar matriz', 'error');
      console.error(error);
    }
  };

  // Função para buscar categorias
  const fetchCategories = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/categories');
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.error('Erro ao buscar categorias:', error);
    }
  };

  // Função para buscar matrizes
  const fetchMatrices = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/matrices');
      const data = await response.json();
      setMatricesOptions(data);
    } catch (error) {
      console.error('Erro ao buscar matrizes:', error);
    }
  };

  // Função para buscar tipos de processos
  const fetchProcessTypes = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/process-types');
      const data = await response.json();
      setProcessTypes(data);
    } catch (error) {
      console.error('Erro ao buscar tipos de processos:', error);
    }
  };
  // useEffect para buscar as opções ao carregar o componente
  useEffect(() => {
    fetchCategories();
    fetchMatrices();
    fetchProcessTypes();
  }, []);

  // Abrir Modal e preencher dados
  const handleEditEquipmentClick = (index) => {
    setCurrentEquipmentIndex(index);
    const equipment = equipments[index];
    setEquipmentName(equipment.equipment_name || '');
    setApplications(equipment.applications || '');
    setObservations(equipment.observations || '');
    setScales(equipment.scales || '');
    setMainSpecs(equipment.main_specs || '');
    setCategoryId(equipment.category_id || '');
    setMatriceId(equipment.matrice_id || '');
    setProcessType(equipment.process_type || '');
    setOpenEquipmentModal(true);
  };

  // Fechar Modal
  const handleCloseEquipmentModal = () => {
    setOpenEquipmentModal(false);
  };
  // Funções para abrir e fechar o modal
  const handleOpenSkillModal = (index) => {
    setCurrentSkillIndex(index);
    setOpenSkillModal(true);
  };

  const handleCloseSkillModal = () => {
    setOpenSkillModal(false);
  };

  // Buscar Research Areas para o ComboBox
  const fetchResearchAreas = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api//research-areas-fields');
      const data = await response.json();
      setResearchAreasOptions(data);
    } catch (error) {
      console.error('Erro ao buscar Research Areas:', error);
    }
  };

  // Carrega as Research Areas quando o componente é montado
  useEffect(() => {
    fetchResearchAreas();
  }, []);

  // Atualização dos estados ao mudar de item
  useEffect(() => {
    if (investigationGroups.length > 0) {
      const currentGroup = investigationGroups[currentGroupIndex];
      setSubEntityIdIG(currentGroup.sub_entity_id || '');
      setResearchLine(currentGroup.research_line || '');
      setResearcherName(currentGroup.researcher_name || '');
      setResearcherCv(currentGroup.researcher_cv || '');
      setEmail(currentGroup.email || '');
      setBiography(currentGroup.biography || '');
      setDescriptionIG(currentGroup.description || '');
    }
  }, [currentGroupIndex, investigationGroups]);

  useEffect(() => {
    if (matrices.length > 0) {
      const currentMatrix = matrices[currentMatrixIndex];
      setMatrixEntityId(currentMatrix.entity_id || '');
      setMatrixObservations(currentMatrix.observations || '');
    }
  }, [currentMatrixIndex, matrices]);

  useEffect(() => {
    if (equipments.length > 0) {
      const currentEquipment = equipments[currentEquipmentIndex];
      setEquipmentName(currentEquipment.equipment_name || '');
      setApplications(currentEquipment.applications || '');      setObservations(currentEquipment.observations || '');
      setScales(currentEquipment.scales || '');
      setMainSpecs(currentEquipment.main_specs || '');
      setCategoryId(currentEquipment.category_id || '');
      setMatriceId(currentEquipment.matrice_id || '');
      setProcessType(currentEquipment.process_type || '');
    }
  }, [currentEquipmentIndex, equipments]);

  useEffect(() => {
    if (skills.length > 0) {
      const currentSkill = skills[currentSkillIndex];
      setMainKeywords(currentSkill.main_keywords || '');
      setResearchTopics(currentSkill.research_topics || '');
      setSpecificKeywords(currentSkill.specific_keywords || '');
      setResearchAreasFieldId(currentSkill.research_areas_field_id || '');
    }
  }, [currentSkillIndex, skills]);

  useEffect(() => {
    if (patents.length > 0) {
      const currentPatent = patents[currentPatentIndex];
      setPublicationNumber(currentPatent.publication_number || '');
      setPublicationDate(currentPatent.publication_date || '');
      setTitle(currentPatent.title || '');
      setInventor(currentPatent.inventor || '');
    }
  }, [currentPatentIndex, patents]);

  useEffect(() => {
    if (projects.length > 0) {
      const currentProject = projects[currentProjectIndex];
      setProjectName(currentProject.project_name || '');
      setLink(currentProject.link || '');
      setOnGoing(currentProject.on_going || false);
      setProjectAcronym(currentProject.project_acronimo || '');
    }
  }, [currentProjectIndex, projects]);

  useEffect(() => {
    const fetchMatriceCategories = async () => {
      try {
        const response = await fetch('https://api.hub4food.colab4food.com/api/matrice-categories');
        if (!response.ok) {
          throw new Error('Erro ao carregar categorias');
        }
        const data = await response.json();
        setMatriceCategories(data); // Certifique-se de que os dados são um array de objetos com `id` e `description`
      } catch (error) {
        console.error('Erro ao buscar categorias:', error);
      }
    };

    fetchMatriceCategories();
  }, []);

  useEffect(() => {
    if (openAddModal) {
      resetForm();
    }
  }, [openAddModal]);

  if (loading) {
    return (
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="h6">Carregar dados...</Typography>
      </Box>
    );
  }

  return (
    <Box>
      
      <BurgerBar />

      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Tabs value={selectedTab} onChange={handleTabChange} centered>
          <Tab label="Entities" /> {/* Nova aba */}
          <Tab label="Faculty" />
          <Tab label="Food Matrices" />
          <Tab label="Equipments" />
          <Tab label="R&I" />
          <Tab label="Patents" />
          <Tab label="Projects" />
        </Tabs>

        <Paper sx={{ p: 3, mt: 2 }}>
          {selectedTab === 0 && (
            <>
              <Card>
                <Container maxWidth="md" sx={{ mt: 4 }}>
                  <Card>
                    <CardContent>
                      <Typography variant="h6">Edit Entity</Typography>
                      <TextField
                        label="Name"
                        fullWidth
                        name="name"
                        value={entity.name}
                        onChange={handleChange}
                        sx={{ mt: 2 }}
                      />
                      <FormControl fullWidth sx={{ mt: 2 }}><InputLabel>Type of Entity</InputLabel><Select
                        name="entity_type_id" value={entity.entity_type_id} onChange={handleChange} label="Tipo de Entidade">{entityTypes.map((type) => (<MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>))}</Select></FormControl>
                      <TextField
                        label="Website"
                        fullWidth
                        name="website"
                        value={entity.website}
                        onChange={handleChange}
                        sx={{ mt: 2 }}
                      />
                      <TextField
                        label="Head Office"
                        fullWidth
                        name="head_office"
                        value={entity.head_office}
                        onChange={handleChange}
                        sx={{ mt: 2 }}
                      />
                      <TextField
                        label="Email"
                        fullWidth
                        name="email_contact"
                        value={entity.email_contact}
                        onChange={handleChange}
                        sx={{ mt: 2 }}
                      />
                      <TextField
                        label="Main Location"
                        fullWidth
                        name="main_location"
                        value={entity.main_location}
                        onChange={handleChange}
                        sx={{ mt: 2 }}
                      />
                      <TextField
                        label="Other Location"
                        fullWidth
                        name="other_location"
                        value={entity.other_location}
                        onChange={handleChange}
                        sx={{ mt: 2 }}
                      />
                      <TextField
                        label="Latitude Coordinates"
                        fullWidth
                        name="latitude_cords"
                        value={entity.latitude_cords}
                        onChange={handleChange}
                        sx={{ mt: 2 }}
                      />
                      <TextField
                        label="Longitude Coordinates"
                        fullWidth
                        name="longitude_cords"
                        value={entity.longitude_cords}
                        onChange={handleChange}
                        sx={{ mt: 2 }}
                      />
                      <TextField
                        label="Description"
                        fullWidth
                        name="description"
                        value={entity.description}
                        onChange={handleChange}
                        sx={{ mt: 2 }}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="is_verified"
                            checked={entity.is_verified}
                            onChange={handleChange}
                          />
                        }
                        label="Verified"
                        sx={{ mt: 2 }}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="is_associate"
                            checked={entity.is_associate}
                            onChange={handleChange}
                          />
                        }
                        label="Associate"
                        sx={{ mt: 2 }}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="is_visible"
                            checked={entity.is_visible}
                            onChange={handleChange}
                          />
                        }
                        label="Visible"
                        sx={{ mt: 2 }}
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={handleUpdateEntity}
                        sx={{ mt: 3 }}
                      >
                        Save Changes
                      </Button>
                    </CardContent>
                  </Card>
                </Container>
              </Card>
            </>
          )}
          {/* Editar Grupo de Pesquisa */}
          {selectedTab === 1 && (
            <>
              <Card sx={{ mt: 2 }}>
                <CardContent>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Investigation Groups</Typography>
                    <Box>
                      <IconButton color="primary" onClick={() => setOpenAddModal(true)}>
                        <Typography variant="body1">Add Investigation Group</Typography>
                      </IconButton>
                      <IconButton color="primary" onClick={() => setOpenAddSubEntityModal(true)}>
                        <Typography variant="body1">Add Sub-Entity</Typography>
                      </IconButton>
                    </Box>
                  </Box>
                  {/* Tabela para os Investigation Groups */}
                  <Box sx={{ mt: 2 }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Research Line</th>
                          <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Entity</th>
                          <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Sub Entity</th>
                          <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {investigationGroups.map((group, index) => (
                          <tr key={group.id}>
                            <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>{group.research_line}</td>
                            <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>{entitiesMap[group.entity_id] || "N.A"}</td>
                            <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>{subEntitiesMap[group.sub_entity_id] || "N.A"}</td>
                            <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                              <IconButton color="primary" onClick={() => handleEditClick(index)} sx={{ mr: 1 }}>
                                <EditIcon />
                              </IconButton>
                              <IconButton color="error" onClick={() => handleDeleteInvestigationGroup(group.id)}>
                                <DeleteIcon />
                              </IconButton>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Box>
                </CardContent>
              </Card>

              {/* Card para Sub Entities */}
              <Card sx={{ mt: 2 }}>
                <CardContent>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Sub Entities</Typography>
                  </Box>
                  <Box sx={{ mt: 2 }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Name</th>
                          <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Type</th>
                          <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Contact</th>
                          <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Location</th>
                          <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {subEntities
                          .filter((subEntity) => subEntity.entity_id === entityId) // Filtra apenas as sub-entidades associadas ao entityId
                          .map((subEntity, index) => (
                            <tr key={subEntity.id}>
                              <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>{subEntity.name}</td>
                              <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>{subEntity.type}</td>
                              <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>{subEntity.contact}</td>
                              <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>{subEntity.location}</td>
                              <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                                <IconButton
                                  color="primary"
                                  onClick={() => {
                                    setSubEntityId(subEntity.id);
                                    setSubEntityType(subEntity.type);
                                    setSubEntityName(subEntity.name);
                                    setSubEntityContact(subEntity.contact);
                                    setSubEntityLocation(subEntity.location);
                                    setOpenEditSubEntityModal(true);
                                  }}
                                  sx={{ mr: 1 }}
                                >
                                  <EditIcon />
                                </IconButton>
                                <IconButton
                                  color="error"
                                  onClick={() => handleDeleteSubEntity(subEntity.id)}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </Box>
                </CardContent>
              </Card>
            </>
          )}

          {/* Modal para adicionar Sub Entity */}
          <Dialog open={openAddSubEntityModal} onClose={() => setOpenAddSubEntityModal(false)}>
            <DialogTitle>Create Sub Entity</DialogTitle>
            <DialogContent>
              <TextField
                fullWidth
                label="Type"
                value={subEntityType}
                onChange={(e) => setSubEntityType(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Name"
                value={subEntityName}
                onChange={(e) => setSubEntityName(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Contact"
                value={subEntityContact}
                onChange={(e) => setSubEntityContact(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Location"
                value={subEntityLocation}
                onChange={(e) => setSubEntityLocation(e.target.value)}
                sx={{ mt: 2 }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenAddSubEntityModal(false)} color="error">Cancel</Button>
              <Button onClick={handleAddSubEntity} color="primary" disabled={loading}>
                {loading ? 'Creating...' : 'Create'}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Modal para editar Sub Entity */}
          <Dialog open={openEditSubEntityModal} onClose={() => setOpenEditSubEntityModal(false)}>
            <DialogTitle>Edit Sub Entity</DialogTitle>
            <DialogContent>
              <TextField
                fullWidth
                label="Type"
                value={subEntityType}
                onChange={(e) => setSubEntityType(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Name"
                value={subEntityName}
                onChange={(e) => setSubEntityName(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Contact"
                value={subEntityContact}
                onChange={(e) => setSubEntityContact(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Location"
                value={subEntityLocation}
                onChange={(e) => setSubEntityLocation(e.target.value)}
                sx={{ mt: 2 }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenEditSubEntityModal(false)} color="error">Cancel</Button>
              <Button onClick={handleEditSubEntity} color="primary" disabled={loading}>
                {loading ? 'Saving...' : 'Save'}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Modal para editar o grupo de pesquisa */}
          <Modal open={openModal} onClose={handleCloseModal}>
            <Box sx={{
              position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
              backgroundColor: 'white', padding: 4, boxShadow: 24, width: '400px'
            }}>
              <Typography variant="h6" component="h2">Edit Investigation Group</Typography>
              {/* ComboBox para Sub-Entity */}
              <FormControl fullWidth sx={{ mt: 2 }}>
                <InputLabel>Sub Entity</InputLabel>
                <Select
                  value={subEntityIdIG || ''}
                  onChange={(e) => setSubEntityIdIG(e.target.value)}
                  label="Sub Entity"
                >
                  <MenuItem value="">None</MenuItem>
                  {subEntities
                    .filter((subEntity) => subEntity.entity_id === entityId) // Filtra apenas as Sub-Entities da mesma entidade
                    .map((subEntity) => (
                      <MenuItem key={subEntity.id} value={subEntity.id}>
                        {subEntity.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <TextField
                label="Research Line"
                fullWidth
                value={researchLine}
                onChange={(e) => setResearchLine(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                label="Researcher Name"
                fullWidth
                value={researcherName}
                onChange={(e) => setResearcherName(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                label="Researcher CV"
                fullWidth
                value={researcherCv}
                onChange={(e) => setResearcherCv(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                label="Email"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                label="Biography"
                fullWidth
                value={biography}
                onChange={(e) => setBiography(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                label="Description"
                fullWidth
                value={descriptionIG}
                onChange={(e) => setDescriptionIG(e.target.value)}
                sx={{ mt: 2 }}
              />
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleEditInvestigationGroup}
                sx={{ mt: 3 }}
              >
                Save Changes
              </Button>
            </Box>
          </Modal>

          <Dialog open={openAddModal} onClose={() => setOpenAddModal(false)}>
            <DialogTitle>Create Investigation Group</DialogTitle>
            <DialogContent>
              {/* Entity ID (readonly) */}
              <TextField fullWidth label="Entity ID" value={entityId} disabled sx={{ mt: 2, display: 'none' }} />

              {/* Sub Entity (Dropdown) */}
              <FormControl fullWidth sx={{ mt: 2 }}>
                <InputLabel>Sub Entity</InputLabel>
                <Select
                  value={subEntityIdIG}
                  onChange={(e) => setSubEntityIdIG(e.target.value)}
                >
                  {subEntities
                    .filter(sub => sub.entity_id === entityId)  // Filtra só as subentidades dessa entidade
                    .map((sub) => (
                      <MenuItem key={sub.id} value={sub.id}>
                        {sub.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              <TextField fullWidth label="Research Line" value={researchLine} onChange={(e) => setResearchLine(e.target.value)} sx={{ mt: 2 }} />
              <TextField fullWidth label="Researcher Name" value={researcherName} onChange={(e) => setResearcherName(e.target.value)} sx={{ mt: 2 }} />
              <TextField fullWidth label="Researcher CV" value={researcherCv} onChange={(e) => setResearcherCv(e.target.value)} sx={{ mt: 2 }} />
              <TextField fullWidth label="Email" value={email} onChange={(e) => setEmail(e.target.value)} sx={{ mt: 2 }} />
              <TextField fullWidth label="Biography" value={biography} onChange={(e) => setBiography(e.target.value)} sx={{ mt: 2 }} />
              <TextField fullWidth label="Description" value={descriptionIG} onChange={(e) => setDescriptionIG(e.target.value)} sx={{ mt: 2 }} />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenAddModal(false)} color="error">Cancel</Button>
              <Button onClick={handleAddInvestigationGroup} color="primary" disabled={loading}>
                {loading ? 'Creating...' : 'Create'}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Editar Matriz */}
          {selectedTab === 2 && (
            <>
              <Card>
                <CardContent>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Food Matrices</Typography>
                    <Box display="flex" alignItems="center">
                      <Typography
                        variant="body1"
                        color="primary"
                        onClick={() => setOpenAddMatrixModal(true)}
                        sx={{ cursor: 'pointer', mr: 2 }}
                      >
                        Create Matrix
                      </Typography>
                      <Typography
                        variant="body1"
                        color="primary"
                        onClick={handleOpenCategoryModal}
                        sx={{ cursor: 'pointer', mr: 2 }}
                      >
                        Create Matrice Category
                      </Typography>
                      <Typography
                        variant="body1"
                        color="primary"
                        onClick={handleOpenSubcategoryModal}
                        sx={{ cursor: 'pointer' }}
                      >
                        Create Matrice Subcategory
                      </Typography>
                    </Box>
                  </Box>
                  {/* Tabela para Food Matrices */}
                  <Box sx={{ mt: 2 }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Observations</th>
                          <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {matrices.map((matrix, index) => (
                          <tr key={matrix.id}>
                            <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                              {matrix.observations}
                            </td>
                            <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                              <IconButton
                                color="primary"
                                onClick={() => handleEditMatrixClick(index)}
                                sx={{ mr: 1 }}
                              >
                                <EditIcon />
                              </IconButton>
                              <IconButton
                                color="error"
                                onClick={() => handleDeleteMatrix(matrix.id)}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Box>
                </CardContent>
              </Card>

              {/* Modal para Matrice Category */}
              <Dialog open={openCategoryModal} onClose={handleCloseCategoryModal}>
                <DialogTitle>Create Matrice Category</DialogTitle>
                <DialogContent>
                  <FormControl fullWidth margin="dense">
                    <InputLabel>Matrice</InputLabel>
                    <Select
                      value={matriceCategoryMatriceId}
                      onChange={(e) => setMatriceCategoryMatriceId(e.target.value)}
                      label="Matrice"
                    >
                      {matrices.map((matrice) => (
                        <MenuItem key={matrice.id} value={matrice.id}>
                          {matrice.observations} {/* Mostra o nome/observação da matriz */}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    label="Description"
                    fullWidth
                    margin="dense"
                    value={matriceCategoryDescription}
                    onChange={(e) => setMatriceCategoryDescription(e.target.value)}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseCategoryModal} color="error">Cancel</Button>
                  <Button onClick={handleCreateMatriceCategory} color="primary">
                    Create
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Modal para Matrice Subcategory */}
              <Dialog open={openSubcategoryModal} onClose={handleCloseSubcategoryModal}>
                <DialogTitle>Create Matrice Subcategory</DialogTitle>
                <DialogContent>
                  <FormControl fullWidth margin="dense">
                    <InputLabel>Matrice Category</InputLabel>
                    <Select
                      value={matriceSubcategoryCategoryId}
                      onChange={(e) => setMatriceSubcategoryCategoryId(e.target.value)}
                      label="Matrice Category"
                    >
                      {matriceCategories.map((category) => (
                        <MenuItem key={category.id} value={category.id}>
                          {category.description} {/* Mostra a descrição da categoria */}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    label="Description"
                    fullWidth
                    margin="dense"
                    value={matriceSubcategoryDescription}
                    onChange={(e) => setMatriceSubcategoryDescription(e.target.value)}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseSubcategoryModal} color="error">Cancel</Button>
                  <Button onClick={handleCreateMatriceSubcategory} color="primary">
                    Create
                  </Button>
                </DialogActions>
              </Dialog>
            </>
          )}

          <Modal open={openMatrixModal} onClose={handleCloseMatrixModal}>
            <Box sx={{
              position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
              backgroundColor: 'white', padding: 4, boxShadow: 24, width: '400px'
            }}>
              <Typography variant="h6" component="h2">Edit Food Matrix</Typography>

              <TextField
                label="Observations"
                fullWidth
                value={matrixObservations}
                onChange={(e) => setMatrixObservations(e.target.value)}
                sx={{ mt: 2 }}
              />
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleEditMatrix}
                sx={{ mt: 3 }}
              >
                Save Changes
              </Button>
            </Box>
          </Modal>

          <Dialog open={openAddMatrixModal} onClose={() => setOpenAddMatrixModal(false)}>
            <DialogTitle>Create Food Matrix</DialogTitle>
            <DialogContent>
              <TextField
                fullWidth
                label="Observations"
                value={newMatrixObservations}
                onChange={(e) => setNewMatrixObservations(e.target.value)}
                sx={{ mt: 2 }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenAddMatrixModal(false)} color="error">Cancel</Button>
              <Button onClick={handleAddMatrix} color="primary" disabled={loading}>
                {loading ? 'Creating...' : 'Create'}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Editar Equipamentos */}
          {selectedTab === 3 && (
            <Card>
              <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h6">Equipments</Typography>
                  <IconButton color="primary" onClick={() => setOpenAddEquipmentModal(true)}>
                    <AddIcon />
                  </IconButton>
                </Box>
                {/* Tabela para Equipamentos */}
                <Box sx={{ mt: 2 }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Equipment Name</th>
                        <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Applications</th>
                        <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>                      {equipments.map((equipment, index) => (
                        <tr key={equipment.id}>
                          <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                            {equipment.equipment_name}
                          </td>
                          <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                            {equipment.applications}
                          </td>
                          <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                            <IconButton
                              color="primary"
                              onClick={() => handleEditEquipmentClick(index)}
                              sx={{ mr: 1 }}
                            >
                              <EditIcon />
                            </IconButton>

                            <IconButton
                              color="error"
                              onClick={() => handleDeleteEquipment(equipment.id)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Box>
              </CardContent>
            </Card>
          )}

          <Modal open={openEquipmentModal} onClose={handleCloseEquipmentModal}>
            <Box sx={{
              position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
              backgroundColor: 'white', padding: 4, boxShadow: 24, width: '400px',
              maxHeight: '80vh',   // Limita a altura máxima a 80% da tela
              overflowY: 'auto'
            }}>
              <Typography variant="h6" component="h2">Edit Equipment</Typography>
              <TextField
                label="Equipment Name"
                fullWidth
                value={equipmentName}
                onChange={(e) => setEquipmentName(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                label="Applications"
                fullWidth
                value={applications}
                onChange={(e) => setApplications(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                label="Observations"
                fullWidth
                value={observations}
                onChange={(e) => setObservations(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                label="Scales"
                fullWidth
                value={scales}
                onChange={(e) => setScales(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                label="Main Specs"
                fullWidth
                value={mainSpecs}
                onChange={(e) => setMainSpecs(e.target.value)}
                sx={{ mt: 2 }}
              />

              {/* Combobox para Category */}
              <TextField
                select
                label="Category"
                fullWidth
                value={categoryId}
                onChange={(e) => setCategoryId(e.target.value)}
                SelectProps={{ native: true }}
                sx={{ mt: 2 }}
              >
                <option value=""></option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.category_name}
                  </option>
                ))}
              </TextField>

              {/* Combobox para Matrice */}
              <TextField
                select
                label="Matrice"
                fullWidth
                value={matriceId}
                onChange={(e) => setMatriceId(e.target.value)}
                SelectProps={{ native: true }}
                sx={{ mt: 2 }}
              >
                <option value=""></option>
                {matricesOptions.map((matrice) => (
                  <option key={matrice.id} value={matrice.id}>
                    {matrice.observations}
                  </option>
                ))}
              </TextField>

              {/* Combobox para Process Type */}
              <TextField
                select
                label="Process Type"
                fullWidth
                value={processType}
                onChange={(e) => setProcessType(e.target.value)}
                SelectProps={{ native: true }}
                sx={{ mt: 2 }}
              >
                <option value=""></option>
                {processTypes.map((process) => (
                  <option key={process.id} value={process.id}>
                    {process.description}
                  </option>
                ))}
              </TextField>

              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleEditEquipment}
                sx={{ mt: 3 }}
              >
                Save Changes
              </Button>
            </Box>
          </Modal>

          <Dialog open={openAddEquipmentModal} onClose={() => setOpenAddEquipmentModal(false)}>
            <DialogTitle>Create Equipment</DialogTitle>
            <DialogContent>
              <TextField
                fullWidth
                label="Equipment Name"
                value={newEquipmentName}
                onChange={(e) => setNewEquipmentName(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Applications"
                value={newApplications}
                onChange={(e) => setNewApplications(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Observations"
                value={newObservations}
                onChange={(e) => setNewObservations(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Scales"
                value={newScales}
                onChange={(e) => setNewScales(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Main Specs"
                value={newMainSpecs}
                onChange={(e) => setNewMainSpecs(e.target.value)}
                sx={{ mt: 2 }}
              />

              {/* Combobox para Category */}
              <TextField
                select
                label="Category"
                fullWidth
                value={newCategoryId}
                onChange={(e) => setNewCategoryId(e.target.value)}
                SelectProps={{ native: true }}
                sx={{ mt: 2 }}
              >
                <option value=""></option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.category_name}
                  </option>
                ))}
              </TextField>

              {/* Combobox para Matrice */}
              <TextField
                select
                label="Matrice"
                fullWidth
                value={newMatriceId}
                onChange={(e) => setNewMatriceId(e.target.value)}
                SelectProps={{ native: true }}
                sx={{ mt: 2 }}
              >
                <option value=""></option>
                {matricesOptions.map((matrice) => (
                  <option key={matrice.id} value={matrice.id}>
                    {matrice.observations}
                  </option>
                ))}
              </TextField>

              {/* Combobox para Process Type */}
              <TextField
                select
                label="Process Type"
                fullWidth
                value={newProcessType}
                onChange={(e) => setNewProcessType(e.target.value)}
                SelectProps={{ native: true }}
                sx={{ mt: 2 }}
              >
                <option value=""></option>
                {processTypes.map((process) => (
                  <option key={process.id} value={process.id}>
                    {process.description}
                  </option>
                ))}
              </TextField>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenAddEquipmentModal(false)} color="error">Cancel</Button>
              <Button onClick={handleAddEquipment} color="primary" disabled={loading}>
                {loading ? 'Creating...' : 'Create'}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Editar Skills */}
          {selectedTab === 4 && (
            <Card>
              <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h6">R&I (Skills)</Typography>
                  <IconButton color="primary" onClick={() => setOpenAddSkillModal(true)}>
                    <AddIcon />
                  </IconButton>
                </Box>
                {/* Tabela para Skills */}
                <Box sx={{ mt: 2 }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Main Keywords</th>
                        <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Research Topics</th>
                        <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {skills.map((skill, index) => (
                        <tr key={skill.id}>
                          <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                            {skill.main_keywords}
                          </td>
                          <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                            {skill.research_topics}
                          </td>
                          <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                            <IconButton
                              color="primary"
                              onClick={() => handleOpenSkillModal(index)}
                              sx={{ mr: 1 }}
                            >
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              color="error"
                              onClick={() => handleDeleteSkill(skill.id)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Box>
              </CardContent>
            </Card>
          )}

          <Modal open={openSkillModal} onClose={handleCloseSkillModal}>
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: 'white',
              padding: 4,
              boxShadow: 24,
              width: '400px',
              maxHeight: '80vh',   // Limita a altura máxima a 80% da tela
              overflowY: 'auto'    // Adiciona scroll vertical
            }}>
              <Typography variant="h6" component="h2">Edit Skill</Typography>
              <TextField
                label="Main Keywords"
                fullWidth
                value={mainKeywords}
                onChange={(e) => setMainKeywords(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                label="Research Topics"
                fullWidth
                value={researchTopics}
                onChange={(e) => setResearchTopics(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                label="Specific Keywords"
                fullWidth
                value={specificKeywords}
                onChange={(e) => setSpecificKeywords(e.target.value)}
                sx={{ mt: 2 }}
              />

              {/* Combobox para Research Areas Field */}
              <TextField
                select
                label="Research Area Field"
                fullWidth
                value={researchAreasFieldId}
                onChange={(e) => setResearchAreasFieldId(e.target.value)}
                SelectProps={{ native: true }}
                sx={{ mt: 2 }}
              >
                <option value=""></option>
                {researchAreasOptions.map((area) => (
                  <option key={area.id} value={area.id}>
                    {area.description}
                  </option>
                ))}
              </TextField>

              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleEditSkill}
                sx={{ mt: 3 }}
              >
                Save Changes
              </Button>
            </Box>
          </Modal>

          <Dialog open={openAddSkillModal} onClose={() => setOpenAddSkillModal(false)}>
            <DialogTitle>Create Skill</DialogTitle>
            <DialogContent>
              <TextField
                fullWidth
                label="Main Keywords"
                value={newMainKeywords}
                onChange={(e) => setNewMainKeywords(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Research Topics"
                value={newResearchTopics}
                onChange={(e) => setNewResearchTopics(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Specific Keywords"
                value={newSpecificKeywords}
                onChange={(e) => setNewSpecificKeywords(e.target.value)}
                sx={{ mt: 2 }}
              />

              {/* Combobox para Research Areas Field */}
              <TextField
                select
                label="Research Area Field"
                fullWidth
                value={newResearchAreasFieldId}
                onChange={(e) => setNewResearchAreasFieldId(e.target.value)}
                SelectProps={{ native: true }}
                sx={{ mt: 2 }}
              >
                <option value=""></option>
                {researchAreasOptions.map((area) => (
                  <option key={area.id} value={area.id}>
                    {area.description}
                  </option>
                ))}
              </TextField>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenAddSkillModal(false)} color="error">Cancel</Button>
              <Button onClick={handleAddSkill} color="primary" disabled={loading}>
                {loading ? 'Creating...' : 'Create'}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Editar Patentes */}
          {selectedTab === 5 && (
            <Card>
              <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h6">Patents</Typography>
                  <IconButton color="primary" onClick={() => setOpenAddPatentModal(true)}>
                    <AddIcon />
                  </IconButton>
                </Box>
                {/* Tabela para Patentes */}
                <Box sx={{ mt: 2 }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Publication Number</th>
                        <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Publication Date</th>
                        <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {patents.map((patent, index) => (
                        <tr key={patent.id}>
                          <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                            {patent.publication_number}
                          </td>
                          <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                            {patent.publication_date}
                          </td>
                          <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                            <IconButton color="primary" onClick={() => handleEditPatentClick(index)} sx={{ mr: 1 }}>
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              color="error"
                              onClick={() => handleDeletePatent(patent.id)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Box>
              </CardContent>
            </Card>
          )}

          <Modal open={openPatentModal} onClose={() => setOpenPatentModal(false)}>
            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'white', padding: 4, boxShadow: 24, width: '400px' }}>
              <Typography variant="h6" component="h2">Edit Patent</Typography>
              <TextField
                label="Publication Number"
                fullWidth
                value={publicationNumber}
                onChange={(e) => setPublicationNumber(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                label="Publication Date"
                fullWidth
                type="date"
                value={publicationDate}
                onChange={(e) => setPublicationDate(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                label="Title"
                fullWidth
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                label="Inventor"
                fullWidth
                value={inventor}
                onChange={(e) => setInventor(e.target.value)}
                sx={{ mt: 2 }}
              />
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleEditPatent}
                sx={{ mt: 3 }}
              >
                Save Changes
              </Button>
            </Box>
          </Modal>

          <Dialog open={openAddPatentModal} onClose={() => setOpenAddPatentModal(false)}>
            <DialogTitle>Create Patent</DialogTitle>
            <DialogContent>
              <TextField
                fullWidth
                label="Publication Number"
                value={newPublicationNumber}
                onChange={(e) => setNewPublicationNumber(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Publication Date"
                type="date"
                value={newPublicationDate}
                onChange={(e) => setNewPublicationDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Title"
                value={newTitle}
                onChange={(e) => setNewTitle(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Inventor"
                value={newInventor}
                onChange={(e) => setNewInventor(e.target.value)}
                sx={{ mt: 2 }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenAddPatentModal(false)} color="error">Cancel</Button>
              <Button onClick={handleAddPatent} color="primary" disabled={loading}>
                {loading ? 'Creating...' : 'Create'}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Editar Projects */}
          {selectedTab === 6 && (
            <Card>
              <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h6">Projects</Typography>
                  <IconButton color="primary" onClick={() => setOpenAddProjectModal(true)}>
                    <AddIcon />
                  </IconButton>
                </Box>
                {/* Tabela para Projects */}
                <Box sx={{ mt: 2 }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Project Name</th>
                        <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Link</th>
                        <th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {projects.map((project, index) => (
                        <tr key={project.id}>
                          <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                            {project.project_name}
                          </td>
                          <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                            {project.link}
                          </td>
                          <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                            <IconButton color="primary" onClick={() => handleEditProjectClick(index)} sx={{ mr: 1 }}>
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              color="error"
                              onClick={() => handleDeleteProject(project.id)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Box>
              </CardContent>
            </Card>
          )}

          <Modal open={openProjectModal} onClose={() => setOpenProjectModal(false)}>
            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'white', padding: 4, boxShadow: 24, width: '400px' }}>
              <Typography variant="h6" component="h2">Edit Project</Typography>
              <TextField
                label="Project Name"
                fullWidth
                value={projectName}
                onChange={(e) => setProjectName(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                label="Link"
                fullWidth
                value={link}
                onChange={(e) => setLink(e.target.value)}
                sx={{ mt: 2 }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={onGoing}
                    onChange={(e) => setOnGoing(e.target.checked)}
                  />
                }
                label="On Going"
                sx={{ mt: 2 }}
              />
              <TextField
                label="Project Acronym"
                fullWidth
                value={projectAcronym}
                onChange={(e) => setProjectAcronym(e.target.value)}
                sx={{ mt: 2 }}
              />
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleEditProject}
                sx={{ mt: 3 }}
              >
                Save Changes
              </Button>
            </Box>
          </Modal>

          <Dialog open={openAddProjectModal} onClose={() => setOpenAddProjectModal(false)}>
            <DialogTitle>Create Project</DialogTitle>
            <DialogContent>
              <TextField
                fullWidth
                label="Project Name"
                value={newProjectName}
                onChange={(e) => setNewProjectName(e.target.value)}
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Link"
                value={newLink}
                onChange={(e) => setNewLink(e.target.value)}
                sx={{ mt: 2 }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={newOnGoing}
                    onChange={(e) => setNewOnGoing(e.target.checked)}
                  />
                }
                label="On Going"
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                label="Project Acronym"
                value={newProjectAcronym}
                onChange={(e) => setNewProjectAcronym(e.target.value)}
                sx={{ mt: 2 }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenAddProjectModal(false)} color="error">Cancel</Button>
              <Button onClick={handleAddProject} color="primary" disabled={loading}>
                {loading ? 'Creating...' : 'Create'}
              </Button>
            </DialogActions>
          </Dialog>

        </Paper>
      </Container>
      {/* Footer Moderno */}

      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={handleCloseNotification}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>

      <Footer />
      </Box>
    
  );
}